import { Button, Card, Meter, Pill, Stack, Text } from '@/design-system'
import { BentoGrid, BentoSpan } from '@/components/Bento'
import { StatTile } from '@/components/StatTile'
import { PageHeader } from '@/app/layouts/PageHeader'
import checkout from '@/app/layouts/CheckoutLayout.module.css'

const HOLDINGS = [
  { name: 'Torre Polanco', city: 'Mexico City', invested: '$2,000.00', value: '$2,148.00', paid: '$142.40', status: 'Renting', progress: 1 },
  { name: 'Chapinero Lofts', city: 'Bogotá', invested: '$1,200.00', value: '$1,200.00', paid: '$72.00', status: 'Building · 38%', progress: 0.38 },
]

const PAYOUTS = [
  ['1 Sep 2026', 'Torre Polanco', '$15.33'],
  ['1 Aug 2026', 'Torre Polanco', '$15.33'],
  ['1 Jul 2026', 'Torre Polanco', '$15.33'],
  ['1 Jun 2026', 'Chapinero Lofts', '$9.00'],
] as const

export function PortfolioScreen() {
  return (
    <>
      <PageHeader
        title="Real assets portfolio"
        subtitle="What you hold, what it paid, and when the next rent lands."
        actions={
          <>
            <Button variant="ghost" size="md" to="/real-assets/secondary">Secondary market</Button>
            <Button variant="primary" size="md" iconStart="add" to="/real-assets">Add a building</Button>
          </>
        }
      />

      <BentoGrid>
        {[
          { label: 'Portfolio value', value: '$3,348.00', note: '+4.6% since you bought' },
          { label: 'Rent paid to you', value: '$214.40', tone: 'positive' as const, note: 'Since Jan 2026' },
          { label: 'Next payout', value: '1 Oct', note: 'About $24.33' },
          { label: 'Locked until', value: 'Q3 2027', note: 'Chapinero completes' },
        ].map((stat) => (
          <StatTile key={stat.label} stat={stat} />
        ))}

        <BentoSpan span={2}>
          <Card tone="light">
            <Text variant="caption" weight="semibold">Your buildings</Text>
            <Stack gap={5} className="pb-mt-4">
              {HOLDINGS.map((holding) => (
                <Stack key={holding.name} gap={3}>
                  <Stack direction="row" justify="between" align="start" gap={3}>
                    <Stack gap={0}>
                      <Text variant="caption" weight="semibold">{holding.name}</Text>
                      <Text variant="eyebrow" tone="secondary">{holding.city}</Text>
                    </Stack>
                    <Pill tone={holding.progress === 1 ? 'accent' : 'warning'}>{holding.status}</Pill>
                  </Stack>
                  <Meter value={holding.progress} height={6} tone="ink" label={`${holding.name} progress`} />
                  <Stack direction="row" gap={6} wrap>
                    {[['Invested', holding.invested], ['Value now', holding.value], ['Rent paid', holding.paid]].map(([label, value]) => (
                      <Stack key={label} gap={0}>
                        <Text variant="eyebrow" tone="secondary">{label}</Text>
                        <Text variant="caption" weight="semibold" numeric>{value}</Text>
                      </Stack>
                    ))}
                  </Stack>
                </Stack>
              ))}
            </Stack>
          </Card>
        </BentoSpan>

        <BentoSpan span={2}>
          <Card tone="light">
            <Text variant="caption" weight="semibold">Rent paid to you</Text>
            <Stack gap={0} className="pb-mt-3">
              {PAYOUTS.map(([date, building, amount]) => (
                <div key={`${date}-${building}`} className={checkout.line}>
                  <Stack grow gap={0} align="start">
                    <Text variant="caption" weight="semibold">{building}</Text>
                    <Text variant="eyebrow" tone="secondary">{date}</Text>
                  </Stack>
                  <Text variant="caption" weight="semibold" tone="positive" numeric>+{amount}</Text>
                </div>
              ))}
            </Stack>
            <Card.Footer>
              <Text variant="eyebrow" tone="secondary">
                Rent lands in your USD account on the 1st. It can fall if a building sits empty.
              </Text>
            </Card.Footer>
          </Card>
        </BentoSpan>
      </BentoGrid>
    </>
  )
}
